import d from "../rule/index.mjs";
import { isEmptyValue as n } from "../util.mjs";
var o = function(r, i, m, e, a) {
  var t = [], p = r.required || !r.required && e.hasOwnProperty(r.field);
  if (p) {
    if (n(i, "date") && !r.required)
      return m();
    if (d.required(r, i, e, t, a), !n(i, "date")) {
      var f;
      i instanceof Date ? f = i : f = new Date(i), d.type(r, f, e, t, a), f && d.range(r, f.getTime(), e, t, a);
    }
  }
  m(t);
};
export {
  o as default
};
//# sourceMappingURL=date.mjs.map
